<template>
  <MDBCard>
    <MDBCardHeader>
      <p class="text-center h1">Kontakt</p>
    </MDBCardHeader>
    <MDBCardBody>
      <div class="row">
        <div class="col-md-8">
          <ContactForm/>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col mt-4 text-center">
              <a href="https://goo.gl/maps/fFSb5vWiAgSXLccA6" title="Umzug Bayern Adresse"><MDBIcon icon="map-marker-alt" size="2x"/></a>
              <p><a href="https://goo.gl/maps/fFSb5vWiAgSXLccA6">Poststr. 1, 85586 Poing</a></p>
            </div>
            </div>
            <div class="row">
              <div class="col mt-4 text-center">
                <a href="tel:004915730438580" title="Umzug Bayern Telefon"><MDBIcon icon="phone" size="2x" /></a>
                <p> <a href="tel:004915730438580">+49 15730438580</a></p>
              </div>
            </div>
            <div class="row">
              <div class="col mt-4 text-center">
                <a href="mailto:info@umzug-bayern.com" title="Umzug Bayern E-Mail Kontakt"><MDBIcon icon="envelope" size="2x" /></a>
                <p><a href="mailto:info@umzug-bayern.com">info@umzug-bayern.com</a></p>
              </div>
            </div>
          </div>
      </div>
    </MDBCardBody>
  </MDBCard>
</template>

<script>
// @ is an alias to /src
import ContactForm from '@/components/ContactForm.vue'
import { MDBCard, MDBCardBody, MDBCardHeader, MDBIcon } from "mdb-vue-ui-kit"

export default {
  name: 'ContactFormCard',
  components: {
    ContactForm,
    MDBIcon,
    MDBCard,
    MDBCardBody,
    MDBCardHeader

  }
}
</script>
